<template>
    <div class="mdl-spinner mdl-js-spinner mdl-spinner--single-color is-active"></div>
</template>

<script>
  export default {
    name: "Loading"
  }
</script>

<style scoped>
  .mdl-spinner {
    margin: 30px auto;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/components/Loading.vue